import { render, staticRenderFns } from "./entries.vue?vue&type=template&id=64fab6a1&scoped=true"
import script from "./entries.vue?vue&type=script&lang=js"
export * from "./entries.vue?vue&type=script&lang=js"
import style0 from "./entries.vue?vue&type=style&index=0&id=64fab6a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fab6a1",
  null
  
)

export default component.exports